// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Roboto;
}

@media (max-width: 1200px) {
  .success_successRow {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
@media (max-width: 576px) {
  .success_successRow {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.success_successMainRow {
  border-radius: 30px;
  height: 70vh;
}
@media (max-width: 1200px) {
  .success_successMainRow {
    padding-left: 3rem;
    padding-right: 2rem;
    height: 85vh;
  }
}
@media (max-width: 992px) {
  .success_successMainRow {
    height: 35vh;
  }
}
@media (max-width: 768px) {
  .success_successMainRow {
    height: 37vh;
  }
}
@media (max-width: 576px) {
  .success_successMainRow {
    padding-left: 1rem !important;
    border-radius: 20px;
    height: 43vh;
  }
}
@media (max-width: 320px) {
  .success_successMainRow {
    padding-left: 1rem !important;
    border-radius: 20px;
    height: 80vh;
  }
}
.success_successP {
  line-height: 2vw;
}
@media (max-width: 1200px) {
  .success_successP {
    line-height: 4vw;
    font-size: 2.5vw;
  }
}
@media (max-width: 576px) {
  .success_successP {
    line-height: 5vw;
    font-size: 3.5vw;
  }
}
.success_successheading {
  background: #1d1a36;
  padding-top: 7vw;
  padding-bottom: 4vw;
  color: #fff;
  text-align: center;
  font-size: 5.1vh;
  font-weight: 700;
  line-height: 100%;
}
@media (max-width: 768px) {
  .success_successheading {
    font-size: 4vw;
  }
}
@media (max-width: 576px) {
  .success_successheading {
    font-size: 6vw;
  }
}
.success_successText {
  color: #fff;
  font-size: 1.6vw;
  font-weight: 400;
  line-height: 39px;
  align-items: flex-start;
}
@media (max-width: 1200px) {
  .success_successText {
    font-size: 3vw;
  }
}
@media (max-width: 576px) {
  .success_successText {
    font-size: 3.5vw;
  }
}
.success_emptyDiv {
  height: 43vh;
}
@media (max-width: 992px) {
  .success_emptyDiv {
    height: 13vh;
  }
}
@media (max-width: 768px) {
  .success_emptyDiv {
    height: 16vh;
  }
}
@media (max-width: 576px) {
  .success_emptyDiv {
    height: 18vh;
  }
}
.success_sucsessBtn {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.72) 0%, rgba(240, 89, 42, 0.59) 100%);
  border-radius: 12.9905277402vh;
  box-sizing: border-box;
  text-decoration: none;
  color: #fff;
  display: block;
  height: 8.6603518268vh;
  letter-spacing: 1px;
  text-decoration: none;
  padding: 2px;
  width: 21.650879567vh;
  z-index: 2;
  margin-top: 3.247631935vh;
  box-shadow: none;
  border: 2px;
}
@media (max-width: 992px) {
  .success_sucsessBtn {
    width: 18vh;
    height: 6vh;
  }
}
@media (max-width: 768px) {
  .success_sucsessBtn {
    width: 19vh;
    height: 7vh;
  }
}
@media (max-width: 576px) {
  .success_sucsessBtn {
    width: 20vh;
    height: 7vh;
  }
}
.success_sucsessBtn span {
  align-items: center;
  background: #201b36;
  border-radius: 5.4127198917vh;
  display: flex;
  justify-content: center;
  height: 100%;
  transition: background 0.5s ease;
  width: 100%;
  font-size: 2.4357239513vh;
  font-weight: 500;
}
@media (max-width: 992px) {
  .success_sucsessBtn span {
    font-size: 1.8vh;
  }
}
@media (max-width: 768px) {
  .success_sucsessBtn span {
    font-size: 2vh;
  }
}
.success .linkTag {
  text-decoration: none;
}
.success_sucsessBtn:hover span {
  background: #f0592a;
  color: white;
}
.success .Arrow {
  margin-left: 5%;
}`, "",{"version":3,"sources":["webpack://./src/Components/OurSuccessStory/ourSuccessStory.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAGI;EADF;IAEI,kBAAA;IACA,mBAAA;EACJ;AACF;AAAI;EALF;IAMI,kBAAA;IACA,mBAAA;EAGJ;AACF;AADE;EACE,mBAAA;EACA,YAAA;AAGJ;AADI;EAJF;IAKI,kBAAA;IACA,mBAAA;IACA,YAAA;EAIJ;AACF;AAHI;EATF;IAUI,YAAA;EAMJ;AACF;AALI;EAZF;IAaI,YAAA;EAQJ;AACF;AANI;EAhBF;IAiBI,6BAAA;IACA,mBAAA;IACA,YAAA;EASJ;AACF;AARI;EArBF;IAsBI,6BAAA;IACA,mBAAA;IACA,YAAA;EAWJ;AACF;AATE;EACE,gBAAA;AAWJ;AAVI;EAFF;IAGI,gBAAA;IACA,gBAAA;EAaJ;AACF;AAZI;EANF;IAOI,gBAAA;IACA,gBAAA;EAeJ;AACF;AAbE;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAeJ;AAdI;EATF;IAUI,cAAA;EAiBJ;AACF;AAfI;EAbF;IAcI,cAAA;EAkBJ;AACF;AAfE;EACE,WAAA;EACA,gBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAgBJ;AAfI;EAPF;IAQI,cAAA;EAkBJ;AACF;AAhBI;EAXF;IAYI,gBAAA;EAmBJ;AACF;AAhBE;EACE,YAAA;AAkBJ;AAdI;EALF;IAMI,YAAA;EAiBJ;AACF;AAhBI;EARF;IASI,YAAA;EAmBJ;AACF;AAlBI;EAXF;IAYI,YAAA;EAqBJ;AACF;AAlBE;EACE,8FAAA;EAKA,8BAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAgBJ;AAfI;EApBF;IAqBI,WAAA;IACA,WAAA;EAkBJ;AACF;AAjBI;EAxBF;IAyBI,WAAA;IACA,WAAA;EAoBJ;AACF;AAnBI;EA5BF;IA6BI,WAAA;IACA,WAAA;EAsBJ;AACF;AAnBE;EACE,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AAqBJ;AApBI;EAXF;IAYI,gBAAA;EAuBJ;AACF;AAtBI;EAdF;IAeI,cAAA;EAyBJ;AACF;AAvBE;EACE,qBAAA;AAyBJ;AAtBE;EACE,mBAAA;EACA,YAAA;AAwBJ;AArBE;EACE,eAAA;AAuBJ","sourcesContent":["* {\n  font-family: Roboto;\n}\n.success {\n  &_successRow {\n    @media (max-width: 1200px) {\n      padding-left: 2rem;\n      padding-right: 2rem;\n    }\n    @media (max-width: 576px) {\n      padding-left: 2rem;\n      padding-right: 2rem;\n    }\n  }\n  &_successMainRow {\n    border-radius: 30px;\n    height: 70vh;\n\n    @media (max-width: 1200px) {\n      padding-left: 3rem;\n      padding-right: 2rem;\n      height: 85vh;\n    }\n    @media (max-width: 992px) {\n      height: 35vh;\n    }\n    @media (max-width: 768px) {\n      height: 37vh;\n    }\n\n    @media (max-width: 576px) {\n      padding-left: 1rem !important;\n      border-radius: 20px;\n      height: 43vh;\n    }\n    @media (max-width: 320px) {\n      padding-left: 1rem !important;\n      border-radius: 20px;\n      height: 80vh;\n    }\n  }\n  &_successP {\n    line-height: 2vw;\n    @media (max-width: 1200px) {\n      line-height: 4vw;\n      font-size: 2.5vw;\n    }\n    @media (max-width: 576px) {\n      line-height: 5vw;\n      font-size: 3.5vw;\n    }\n  }\n  &_successheading {\n    background: #1d1a36;\n    padding-top: 7vw;\n    padding-bottom: 4vw;\n    color: #fff;\n    text-align: center;\n    font-size: 5.1vh;\n    font-weight: 700;\n    line-height: 100%;\n    @media (max-width: 768px) {\n      font-size: 4vw;\n    \n    }\n    @media (max-width: 576px) {\n      font-size: 6vw;\n    \n    }\n  }\n  &_successText {\n    color: #fff;\n    font-size: 1.6vw;\n\n    font-weight: 400;\n    line-height: 39px;\n    align-items: flex-start;\n    @media (max-width: 1200px) {\n      font-size: 3vw;\n    }\n\n    @media (max-width: 576px) {\n      font-size: 3.5vw;\n    }\n  }\n\n  &_emptyDiv {\n    height: 43vh;\n    // @media (max-width: 1200px) {\n    //   height: 10vh;\n    // }\n    @media (max-width: 992px) {\n      height: 13vh;\n    }\n    @media (max-width: 768px) {\n      height: 16vh;\n    }\n    @media (max-width: 576px) {\n      height: 18vh;\n    }\n  }\n\n  &_sucsessBtn {\n    background: linear-gradient(\n      90deg,\n      rgba(255, 255, 255, 0.72) 0%,\n      rgba(240, 89, 42, 0.59) 100%\n    );\n    border-radius: 12.990527740189446vh;\n    box-sizing: border-box;\n    text-decoration: none;\n    color: #fff;\n    display: block;\n    height: 8.660351826792963vh;\n    letter-spacing: 1px;\n    text-decoration: none;\n    padding: 2px;\n    width: 21.650879566982407vh;\n    z-index: 2;\n    margin-top: 3.2476319350473615vh;\n    box-shadow: none;\n    border: 2px;\n    @media (max-width:992px) {\n      width: 18vh;\n      height: 6vh;\n    }\n    @media (max-width:768px) {\n      width: 19vh;\n      height: 7vh;\n    }\n    @media (max-width:576px) {\n      width: 20vh;\n      height: 7vh;\n    }\n  }\n\n  &_sucsessBtn span {\n    align-items: center;\n    background: #201b36;\n    border-radius: 5.412719891745602vh;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    transition: background 0.5s ease;\n    width: 100%;\n    font-size: 2.435723951285521vh;\n    font-weight: 500;\n    @media (max-width:992px) {\n      font-size: 1.8vh;\n    }\n    @media (max-width:768px) {\n      font-size: 2vh;\n    }\n  }\n  .linkTag {\n    text-decoration: none;\n  }\n\n  &_sucsessBtn:hover span {\n    background: #f0592a;\n    color: white;\n  }\n\n  .Arrow {\n    margin-left: 5%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
